import React from 'react'
import Box from '@mui/material/Box'
import CustomChip from 'src/@core/components/mui/chip'

export type FranchiseStatusSource = {
  isActive?: boolean | null
} | null

/** Active / inactive chip aligned with franchise detail header (`layout.tsx`). */
export const FranchiseBreadcrumbStatus: React.FC<{ franchise: FranchiseStatusSource }> = ({ franchise }) => {
  if (!franchise) {
    return null
  }

  const active = Boolean(franchise.isActive)

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.25 }}>
      <CustomChip
        rounded
        size='small'
        skin='light'
        label={active ? 'Active' : 'Inactive'}
        color={active ? 'success' : 'error'}
        sx={{ marginLeft: '0 !important' }}
      />
    </Box>
  )
}
